import FeatureBox from "components/conversion/FeatureBox";
import classNames from "components/ui/classNames";
import { FormattedMessage, useIntl } from "react-intl";

interface CompanyPageCtaProps {
  displayOrigin?: string;
}
export default function CompanyPageCta({ displayOrigin }: CompanyPageCtaProps) {
  const intl = useIntl();
  return (
    <div className="mx-auto w-full max-w-7xl px-4 xl:px-0">
      <div
        className={classNames(
          "flex flex-col items-center justify-center gap-y-6 rounded-xl bg-indigo-50 p-6",
          "dark:bg-indigo-600/5 dark:ring-slate-900 dark:ring-offset-0 dark:ring-offset-slate-900",
        )}
      >
        <div className="max-w-sm">
          <FeatureBox
            displayOrigin={displayOrigin || "Company page"}
            buttonText={intl.formatMessage({ defaultMessage: "Quero ser Premium", id: "ghW3+x" })}
            callToActionText={
              <FormattedMessage
                defaultMessage="Destrave 100% dos dados e tenha acesso imediato as informações atualizadas de mais de 6.000 ativos!"
                id="+sub4T"
              />
            }
            className="border-transparent"
            featureHighlights={[
              intl.formatMessage({ defaultMessage: "Acesso completo sem restrições", id: "qSwe06" }),
              intl.formatMessage({ defaultMessage: "Histórico de dados ilimitado", id: "wso7wX" }),
              intl.formatMessage({ defaultMessage: "Vídeos de análises", id: "Q5jUDe" }),
              intl.formatMessage({ defaultMessage: "Destaques trimestrais", id: "E9T27u" }),
              intl.formatMessage({ defaultMessage: "Tabela customizável", id: "gqYx+x" }),
              intl.formatMessage({ defaultMessage: "Ranking", id: "YJ60t1" }),
              intl.formatMessage({ defaultMessage: "Discussões", id: "aDdimF" }),
            ]}
          />
        </div>
      </div>
    </div>
  );
}
